<template>
    <div>
        <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsParteneri" :allowColumnResizing="true"
            key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'" :show-borders="true"
            :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-column-lines="false"
            :allowMerging="'Cells'" height="100%" @exporting="onExporting" :hover-state-enabled="true"
            :remote-operations="true" @row-click="onRowClick">
            <DxSelection mode="single" />
            <DxStateStoring :enabled="true" :filterValue="false" :savingTimeout="100"
                storage-key="gridParteneriState" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" :show-info="true"
                :show-navigation-buttons="true" />
            <DxColumnChooser :enabled="true" :allow-search="true" title="Selector coloane" />
            <DxSorting mode="multiple" />
            <DxHeaderFilter :visible="false" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxEditing :allow-updating="false" />
            <DxSearchPanel :visible="true" placeholder="Cauta Partener" :search-visible-columns-only="true" />
            <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
            <DxFilterRow :visible="true" />
            <DxGridToolbar>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <DxButton icon="plus" type="success" @click="onAddClick" hint="Adauga Partener" />
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <DxButton icon="refresh" @click="onRefreshClick" hint="Reimprospateaza" />
                </DxGridToolbarItem>
                <DxGridToolbarItem name="exportButton" />
                <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" hint="Alege Coloanele" />
                <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
            </DxGridToolbar>

            <DxColumn data-field="Nume" />
            <DxColumn data-field="Cod" :visible="false" />
            <DxColumn data-field="CUI" />
            <DxColumn data-field="Fiscal" :visible="false">
                <DxLookup :data-source="dsParteneriFiscal" value-expr="Cod" display-expr="Nume" />
            </DxColumn>
            <DxColumn data-field="Client" :visible="false" />
            <DxColumn data-field="Furnizor" :visible="false" />
            <DxColumn data-field="Numar" :visible="false" />
            <DxColumn data-field="Strada" :visible="false" />
            <DxColumn data-field="Localitate" :visible="false" />
            <DxColumn data-field="JudetID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="TaraID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="ZonaID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="Cont" :visible="false" />
            <DxColumn data-field="Banca" :visible="false" />
            <DxColumn data-field="Litigiu" :visible="false" />
            <DxColumn data-field="Extern" :visible="false" />
            <DxColumn data-field="Intern" :visible="false" />
            <DxColumn data-field="Observatii" :visible="false" />
            <DxColumn data-field="faraScadenta" :visible="false" />
            <DxColumn data-field="ValutaID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="Director" :visible="false" />
            <DxColumn data-field="Fax" :visible="false" />
            <DxColumn data-field="Tel" :visible="false" caption="Telefon" />
            <DxColumn data-field="Email" :visible="false" />
            <DxColumn data-field="www" :visible="false" />
            <DxColumn data-field="GrupID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="CP" :visible="false" caption="Cod Postal" />
            <DxColumn data-field="CStrada" :visible="false" caption="Strada Corespondenta" />
            <DxColumn data-field="CLocalitate" :visible="false" caption="Localitate Corespondenta" />
            <DxColumn data-field="CJudetID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="CTaraID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="CCP" :visible="false" caption="Cod Postal Corespondenta" />
            <DxColumn data-field="Bloc" :visible="false" />
            <DxColumn data-field="CBloc" :visible="false" caption="Bloc Corespondenta" />
            <DxColumn data-field="Numarstrada" :visible="false" caption="Numar Strada" />
            <DxColumn data-field="Scarabloc" :visible="false" caption="Scara Bloc" />
            <DxColumn data-field="CNumarstrada" :visible="false" caption="Numar Strada Corespondenta" />
            <DxColumn data-field="CScarabloc" :visible="false" caption="Scara Bloc Corespondenta" />
            <DxColumn data-field="Scadenta" :visible="false" />
            <DxColumn data-field="AgentID" caption="Responsabil" :visible="true" :allow-hiding="false" :allow-search="false">
                <DxLookup :data-source="dsAgenti" value-expr="Id" display-expr="Nume" />
            </DxColumn>
            <DxColumn data-field="Angajat" :visible="false" />
            <DxColumn data-field="Memo" :visible="false" />
            <DxColumn data-field="CreditLimita" :visible="false" />
            <DxColumn data-field="DirectorEconomic" :visible="false" />
            <DxColumn data-field="PersoanaContact" :visible="false" />
            <DxColumn data-field="AplicaTVAlaIncasare" :visible="false" caption="Aplica TVA la Incasare" />
            <DxColumn data-field="CifraAfacere" :visible="false" caption="Cifra Afacere" />
            <DxColumn data-field="NrAngajati" :visible="false" caption="Nr. Angajati" />
            <DxColumn data-field="Activ" :visible="false" />
            <DxColumn data-field="Owner" caption="Owner" :visible="false" />
            <DxColumn data-field="CalculezPenalitati" :visible="false" caption="Calculez Penalitati" />
            <DxColumn data-field="ParRecomandareID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="CapitalSocial" :visible="false" />
            <DxColumn data-field="AngajatID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="ExternUE" :visible="false" />
            <DxColumn data-field="StructuraLegaturaID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="PartenerMasterID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="RegimSpecialTVA" :visible="false" />
            <DxColumn data-field="Et" :visible="false" caption="Etaj" />
            <DxColumn data-field="Ap" :visible="false" caption="Apartament" />
            <DxColumn data-field="Adresa" />
            <DxColumn data-field="CEt" :visible="false" caption="Etaj Corespondenta" />
            <DxColumn data-field="CAp" :visible="false" caption="Apartament Corespondenta" />
            <DxColumn data-field="CAdresa" :visible="false" caption="Adresa Corespondenta" />
            <DxColumn data-field="CalculezPenalitatiDeLa" :visible="false" caption="Calculez Penalitati De La" />
            <DxColumn data-field="Sufix" :visible="false" />
            <DxColumn data-field="Prefix" :visible="false" />
            <DxColumn data-field="Caen" :visible="false" />
            <DxColumn data-field="PunctID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="ParentID" :visible="false" :show-in-column-chooser="false" />
            <DxColumn data-field="DataCreare" :visible="false" :show-in-column-chooser="true" />
            <DxColumn data-field="UserCreare" :visible="false" :show-in-column-chooser="true" />

        </DxDataGrid>

        <DxPopupAdd :visible="isPartnerModalVisible" :width="1450" :height="684" :show-title="true"
            title="Adăugare Partener Nou" @hiding="isPartnerModalVisible = false">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-add"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare partener</div>
                            <div class="popup-header-subtitle">
                                Completează detaliile partenerului
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nou
                        </span>
                    </div>
                </div>
            </template>
            <div class="popup-body-modern">
                <DxForm :form-data="newPartnerData" :col-count="3" :col-span="3">

                    <DxFormItem item-type="group" caption="Identitate & Fiscal" :col-count="6"
                        css-class="form-section-simple form-section-card">
                        <DxFormItem data-field="CUI" :label="{ text: 'CUI/CNP' }" :editor-options="cuiOptions"
                            :col-span="3">
                            <DxRequiredRule message="Câmpul 'CUI/CNP' este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem data-field="Nume" :col-span="3">
                            <DxRequiredRule message="Câmpul 'Nume' este obligatoriu" />
                        </DxFormItem>


                        <DxFormItem data-field="Fiscal" editor-type="dxSelectBox" :col-span="4"
                            :label="{ text: 'Tip Fiscal' }" :editor-options="{
                                dataSource: dsParteneriFiscal,
                                displayExpr: 'Nume',
                                valueExpr: 'Cod',
                                placeholder: 'Selectează Tip Fiscal',
                                searchEnabled: true,
                                onEnterKey: onDropDownEnterKey
                            }">
                            <DxRequiredRule message="Câmpul 'Tip Fiscal' este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem data-field="Numar" :label="{ text: 'Regim Comerț' }" :col-span="2" />
                        <DxFormItem data-field="Caen" :label="{ text: 'Cod CAEN' }" :col-span="2" />

                        <DxFormItem data-field="Owner" :editor-options="{ readOnly: true }"
                            :label="{ text: 'Responsabil' }" :col-span="2" />
                        <DxFormItem data-field="Cont" :label="{ text: 'IBAN' }" :col-span="2" />
                        <DxFormItem data-field="Memo" :col-span="6" :editor-options="{ height: 80 }"
                            editor-type="dxTextArea" />
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Sediu Social" :col-span="1" :col-count="4"
                        css-class="form-section-simple form-section-card">

                        <DxFormItem data-field="Strada" :col-span="3" />
                        <DxFormItem data-field="Numarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                        <DxFormItem data-field="Bloc" :col-span="1" />
                        <DxFormItem data-field="Scarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                        <DxFormItem data-field="Et" :col-span="1" :label="{ text: 'Etaj' }" />
                        <DxFormItem data-field="Ap" :col-span="1" :label="{ text: 'Ap.' }" />

                        <DxFormItem data-field="Localitate" :col-span="3" />
                        <DxFormItem data-field="CP" :col-span="1" :label="{ text: 'C.P.' }" />

                        <DxFormItem data-field="Adresa" :col-span="4" editor-type="dxTextArea"
                            :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Domiciliu Fiscal" :col-span="1" :col-count="4"
                        css-class="form-section-simple form-section-card">
                        <DxFormItem data-field="CStrada" :col-span="3" :label="{ text: 'Strada' }" />
                        <DxFormItem data-field="CNumarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                        <DxFormItem data-field="CBloc" :col-span="1" :label="{ text: 'Bl.' }" />
                        <DxFormItem data-field="CScarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                        <DxFormItem data-field="CEt" :col-span="1" :label="{ text: 'Etaj' }" />
                        <DxFormItem data-field="CAp" :col-span="1" :label="{ text: 'Ap.' }" />

                        <DxFormItem data-field="CLocalitate" :col-span="3" :label="{ text: 'Localitate' }" />
                        <DxFormItem data-field="CCP" :col-span="1" :label="{ text: 'C.P.' }" />

                        <DxFormItem data-field="CAdresa" :col-span="4" editor-type="dxTextArea"
                            :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                    </DxFormItem>

                    <DxFormItem :col-count="3" :col-span="3">
                        <div class="show-more-container" style="display: flex; justify-content: center; margin: 1px 0;">
                            <DxButton :element-attr="{ class: 'show-more-btn' }"
                                :text="showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare'"
                                :icon="showExtendedDetails ? 'chevronup' : 'chevrondown'" type="normal"
                                styling-mode="text" @click="showExtendedDetails = !showExtendedDetails" />

                        </div>
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Configurare Financiară & Comericală"
                        :visible="showExtendedDetails" :col-count="2">
                        <DxFormItem :label="{ text: 'Bancă (Internă)' }">
                            <DxDropDownBox v-model:value="sBanci" :data-source="dsBanci" display-expr="Nume"
                                value-expr="Id" :show-clear-button="true" placeholder="Selectează bancă"
                                content-template="gridContent" :drop-down-options="{ width: 200 }"
                                :accept-custom-value="true" @enter-key="onDropDownEnterKey"
                                @input="onDropDownSearchInput($event, 'dsBanci', 'Nume')">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsBanci" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="280" :remote-operations="true"
                                            @row-click="onBanciRowClick">
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxScrolling mode="virtual" />
                                            <DxGridToolbar>
                                                <DxGridToolbarItem location="after">
                                                    <DxButton icon="plus" type="success" height="25px" width="25px"
                                                        @click="onAddNewBank" />
                                                </DxGridToolbarItem>
                                                <DxGridToolbarItem name="searchPanel" />
                                            </DxGridToolbar>
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem :label="{ text: 'Valută' }">
                            <DxDropDownBox v-model:opened="isValutaGridBoxOpened" :data-source="valutaSelectat"
                                v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id"
                                placeholder="RON" :accept-custom-value="true" @enter-key="onDropDownEnterKey"
                                @input="onDropDownSearchInput($event, 'dsValuta', 'Simbol')">
                                <template #content="{ data }">
                                    <DxDataGrid :data-source="dsValuta" :selected-row-keys="sValuta ? [sValuta] : []"
                                        :columns="['Simbol']" :hover-state-enabled="true" height="100%"
                                        @selection-changed="onValueSelectedValuta($event)">
                                        <DxSelection mode="single" />
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxSearchPanel :visible="true" placeholder="Caută..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem data-field="CapitalSocial" />
                        <DxFormItem data-field="CifraAfacere" />
                        <DxFormItem data-field="NrAngajati" :label="{ text: 'Nr. Angajati' }" />

                        <DxFormItem :label="{ text: 'Grup *' }" :col-span="1">
                            <DxDropDownBox ref="grupDropBox" v-model:value="sGrupuri" :data-source="dsGrupuri" display-expr="Nume"
                                value-expr="Id" :show-clear-button="true" placeholder="Selectează "
                                content-template="gridContent" :drop-down-options="{ width: 400 }"
                                :accept-custom-value="true" :is-valid="!grupError"
                                @enter-key="onDropDownEnterKey"
                                @input="onDropDownSearchInput($event, 'dsGrupuri', 'Nume')">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsGrupuri" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="280" :remote-operations="true"
                                            @row-click="onGrupuriRowClick">
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxScrolling mode="virtual" />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem :label="{ text: 'Zona *' }" :col-span="1">
                            <DxDropDownBox ref="zonaDropBox" v-model:value="sZona" :data-source="dsZona" display-expr="Nume"
                                value-expr="Id" :show-clear-button="true" placeholder="Selectează "
                                content-template="gridContent" :drop-down-options="{ width: 200 }"
                                :accept-custom-value="true" :is-valid="!zonaError"
                                @enter-key="onDropDownEnterKey"
                                @input="onDropDownSearchInput($event, 'dsZona', 'Nume')">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsZona" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="280" :remote-operations="true"
                                            @row-click="onZonaRowClick">
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxScrolling mode="virtual" />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem data-field="AdaosPret" :col-span="1" />
                        <DxFormItem data-field="Scadenta" :col-span="1" />

                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Contacte & Diverse" :visible="showExtendedDetails"
                        :col-count="2">
                        <DxFormItem data-field="Tel" :label="{ text: 'Telefon' }" />
                        <DxFormItem data-field="Fax" />
                        <DxFormItem data-field="Email" />

                        <DxFormItem data-field="Director" />



                        <DxFormItem data-field="Observatii" :col-span="2" :editor-options="{ height: 100 }"
                            editor-type="dxTextArea" />

                    </DxFormItem>

                    <DxFormItem item-type="group" caption="System Flags" :visible="showExtendedDetails" :col-count="2"
                        :col-span="2">
                        <DxFormItem data-field="AplicaTVAlaIncasare" editor-type="dxCheckBox"
                            :label="{ text: 'TVA la Încasare' }" />
                        <DxFormItem data-field="RegimSpecialTVA" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Intern" editor-type="dxCheckBox"
                            :editor-options="{ onValueChanged: handleInternChange }" />

                        <DxFormItem data-field="Extern" editor-type="dxCheckBox" :label="{ text: 'Extern Non UE' }"
                            :editor-options="{ onValueChanged: handleExternChange }" />

                        <DxFormItem data-field="ExternUE" editor-type="dxCheckBox" :label="{ text: 'Extern UE' }"
                            :editor-options="{ onValueChanged: handleExternUEChange }" />


                        <DxFormItem data-field="Client" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Furnizor" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Activ" editor-type="dxCheckBox" />

                        <DxFormItem data-field="AplicaTvaDefalcat" editor-type="dxCheckBox"
                            :label="{ text: 'Split TVA' }" />
                        <DxFormItem data-field="faraScadenta" editor-type="dxCheckBox" />
                        <DxFormItem data-field="CalculezPenalitati" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Litigiu" editor-type="dxCheckBox" />
                    </DxFormItem>

                </DxForm>
                <div class="form-footer  footer-modern">
                    <div class="footer-right" style="margin-top: 1px; text-align: right;">
                        <DxButton text="Salvează Compania" type="success" @click="onSaveNewPartner" height="32px"
                            width="200px" styling-mode="outlined" />
                        <DxButton text="Închide" @click="isPartnerModalVisible = false" height="32px" width="200px"
                            styling-mode="outlined" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>

        <DxPopupAdd :visible="isBankModalVisible" :width="800" :height="550" :show-title="true" title="Adăugare Bancă"
            @hiding="isBankModalVisible = false">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-add"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare bancă</div>
                            <div class="popup-header-subtitle">
                                Completează detaliile băncii
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nou
                        </span>
                    </div>
                </div>
            </template>
            <div class="popup-body-modern">
                <DxForm :form-data="newBankData" :col-count="2" :col-span="2">

                    <DxFormItem data-field="Ordine" />
                    <DxFormItem data-field="Cod" />
                    <DxFormItem data-field="Nume" />

                    <DxFormItem :label="{ text: 'Valută' }">
                        <DxDropDownBox v-model:value="sValute" :data-source="dsValute" display-expr="Simbol"
                            value-expr="Id" :show-clear-button="true" placeholder="RON" content-template="gridContent"
                            :accept-custom-value="true" @enter-key="onDropDownEnterKey"
                            @input="onDropDownSearchInput($event, 'dsValute', 'Simbol')">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsValute" :columns="['Simbol']"
                                        :hover-state-enabled="true" :height="280" :remote-operations="true"
                                        @row-click="onValuteRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>
                    <DxFormItem data-field="CodIBAN" />
                    <DxFormItem data-field="CodBIC" />
                    <DxFormItem data-field="CodSWIFT" />
                    <DxFormItem data-field="TextFC" />
                    <DxFormItem data-field="Principala" editor-type="dxCheckBox" />
                    <DxFormItem data-field="Activ" editor-type="dxCheckBox" />
                </DxForm>
                <div class="form-footer footer-fixed footer-modern">
                    <div class="footer-right" style="margin-top: 10px; text-align: right;">
                        <DxButton text="Salvează Banca" type="success" @click="onSaveNewBank" height="32px"
                            width="200px" styling-mode="outlined" />
                        <DxButton text="Închide" @click="isBankModalVisible = false" height="32px" width="200px"
                            styling-mode="outlined" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator'
import { DxForm, DxTabbedItem, DxTab } from "devextreme-vue/form"
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxItem as DxFormItem } from 'devextreme-vue/form';
import {
    DxItem as DxGridToolbarItem,
    DxLookup,
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar as DxGridToolbar,
    DxEditing,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxForm as DxFormGrid,
    DxToolbar,
    DxScrolling,
    DxHeaderFilter,
    DxPager
} from 'devextreme-vue/data-grid';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { DxItem } from 'devextreme-vue/form';
import JwtServices from '@/services/JwtServices';
import PAR_Parteneri from "@/services/PAR/PAR_Parteneri";
import AnafService from '@/services/AnafService';
export default defineComponent({
    name: 'GridTabParteneri',
    components: {
        DxGridToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxEditing,
        DxPopupAdd,
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxScrollView,
        DxLookup,
        DxColumnChooser,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxSearchPanel,
        DxMasterDetail,
        DxPopup,
        DxToolbarItem,
        DxFormGrid,
        DxGridToolbarItem,
        DxScrolling,
        DxHeaderFilter,
        DxDropDownButton,
        DxFormItem,
        DxDropDownBox,
        DxTabbedItem,
        DxTab,
        DxItem,
        DxToolbar,
        DxRequiredRule,
        DxPager
    },

    data() {
        return {
            dsAgenti: {} as ODataStore,
            dsGrupuri: {} as ODataStore,
            dsParteneriFiscal: {} as ODataStore,
            dsValute: {} as ODataStore,
            dsZona: {} as ODataStore,
            dsParteneri: {} as ODataStore,
            dsBanci: {} as ODataStore,
            isPartnerModalVisible: false,
            isBankModalVisible: false,
            isZonaGridBoxOpened: false,
            isValutaGridBoxOpened: false,
            isBanciGridBoxOpened: false,
            isGrupuriGridBoxOpened: false,
            isValuteGridBoxOpened: false,
            showExtendedDetails: false,
            sPartener: null,
            sValuta: null,
            dsValuta: {} as ODataStore,
            valutaSelectat: [],
            sBanci: null,
            sGrupuri: null,
            sZona: null,
            grupError: false,
            zonaError: false,
            sValute: null,
            sParteneriFiscal: null,
            Username: " ",
            formData: {
                Nume: '',
                Prenume: null,
                DataNasterii: null,
                Sex: '',
                Titlu: '',
                AccountID: null,
                Email: '',
                TelMunca: '',
                TelMobil: '',
                Fax: '',
                TaraID: '',
                JudetID: null,
                LocalitateID: null,
                Adresa: '',
                MetodaContact: '',
                Note: '',
                Activ: true,
                Owner: '',
                Imagine: null,
                ContactPrimar: true
            },
            newPartnerData: {
                Nume: '',
                CUI: '',
                Cod: '',
                Fiscal: '',
                Numar: '',
                Strada: '',
                Localitate: '',
                JudetID: null,
                TaraID: null,
                ZonaID: null,
                Cont: '',
                Banca: '',
                Litigiu: null,
                Extern: null,
                Intern: null,
                Observatii: '',
                AdaosPret: null,
                faraScadenta: null,
                ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                Director: '',
                Fax: '',
                Tel: '',
                Email: '',
                www: '',
                GrupID: null,
                CP: '',
                CStrada: '',
                CLocalitate: '',
                CJudetID: null,
                CTaraID: null,
                CCP: '',
                Bloc: '',
                CBloc: '',
                Numarstrada: '',
                Scarabloc: '',
                CNumarstrada: '',
                CScarabloc: '',
                Scadenta: null,
                AgentID: null,
                Angajat: null,
                Memo: '',
                CreditLimita: null,
                DirectorEconomic: '',
                PersoanaContact: '',
                AplicaTVAlaIncasare: null,
                CifraAfacere: null,
                NrAngajati: null,
                Activ: true,
                Client: true,
                Furnizor: true,
                Owner: '',
                CalculezPenalitati: null,
                ParRecomandareID: null,
                CapitalSocial: null,
                AngajatID: null,
                ExternUE: null,
                StructuraLegaturaID: null,
                PartenerMasterID: null,
                RegimSpecialTVA: null,
                AplicaTvaDefalcat: null,
                Et: '',
                Ap: '',
                Adresa: '',
                CEt: '',
                CAp: '',
                CAdresa: '',
                CalculezPenalitatiDeLa: null,
                Prefix: '',
                Sufix: '',
                Caen: '',
                PunctID: null,
                ParentID: null,
            },
            newBankData: {
                PartenerID: null,
                Cod: null,
                Nume: null,
                CodIBAN: null,
                CodBIC: null,
                Principala: null,
                CodSWIFT: null,
                ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                Ordine: null,
                Activ: null,
                TextFC: null,

            },
            tabs: [
                "Info. General",
                "Info. Financiar",
                "Info. Comercial",
                "Adresă Reședință",
                "Adresă Corespondență",
                "Diverse",
                "Stare"
            ],

        };
    },
    computed: {
        cuiOptions() {
            return {
                valueChangeEvent: 'keyup',
                onValueChanged: this.handleCuiChange,
                buttons: [{
                    name: 'searchAnaf',
                    location: 'after',
                    options: {
                        icon: 'search',
                        width: 26,
                        height: 26,
                        type: 'default',
                        hint: 'Caută în ANAF',
                        onClick: () => this.onSearchAnaf()
                    }
                }]
            };
        }
    },
    methods: {
        handleCuiChange(e) {
            const valoareNoua = e.value;
            this.newPartnerData.Cod = valoareNoua;
        },
        GetUser() {
            this.Username = JwtServices.GetUsername();
        },
        createODataContext() {
            this.dsParteneri = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                fieldTypes: {
                    AgentID: 'Guid',
                    GrupID: 'Guid',
                    ZonaID: 'Guid',
                    JudetID: 'Guid',
                    TaraID: 'Guid',
                },
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                    //e.params.$expand = "Grup($select=Nume),Zona($select=Nume)";
                }
            });
            this.dsParteneriFiscal = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            });

            this.dsBanci = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });

            this.dsZona = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });
            this.dsValute = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Simbol',
                ],

            });
            this.dsValuta = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Simbol',
                ],

            });
            this.dsAgenti = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti',
                key: 'Id',
                keyType: 'Guid',
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                    };
                },
            });

            this.dsGrupuri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Id',
                    'Nume',
                    'Cod'
                ],
                sort: [
                    { selector: 'Cod', desc: false }
                ]

            });
        },

        onBanciRowClick(e) {
            this.isBanciGridBoxOpened = false;

            if (e.data) {
                this.sBanci = e.data.Id;
                this.newPartnerData.Banca = e.data.Nume;

                this.newBankData.Banca = e.data.Nume;
                this.newBankData.PartenerId = e.data.Id;
            } else {
                this.sBanci = null;
                this.newPartnerData.Banca = '';
                this.newBankData.PartenerId = null;
            }
        },
        onValueSelectedValuta(e) {
            this.isValutaGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sValuta = e.selectedRowKeys[0];
            } else {
                this.sValuta = null;
            }
            this.newPartnerData.ValutaID = this.sValuta;
        },

        onValuteRowClick(e) {
            this.isValuteGridBoxOpened = false;

            if (e.data) {
                this.sValute = e.data.Id;
                if (this.isBankModalVisible) {
                    this.newBankData.ValutaID = e.data.Id;
                } else if (this.isPartnerModalVisible) {
                    this.newPartnerData.ValutaID = e.data.Id;
                }
            } else {
                this.sValute = null;
                if (this.isBankModalVisible) {
                    this.newBankData.ValutaID = null;
                } else if (this.isPartnerModalVisible) {
                    this.newPartnerData.ValutaID = null;
                }
            }
        },

        onGrupuriRowClick(e) {
            this.isGrupuriGridBoxOpened = false;

            if (e.data) {
                this.sGrupuri = e.data.Id;
                this.newPartnerData.GrupID = e.data.Id;
                this.grupError = false;
            } else {
                this.sGrupuri = null;
            }

        },
        onZonaRowClick(e) {
            this.isZonaGridBoxOpened = false;

            if (e.data) {
                this.sZona = e.data.Id;
                this.newPartnerData.ZonaID = e.data.Id;
                this.zonaError = false;
            } else {
                this.sZona = null;
            }

        },
        onAddNewPartener() {
            this.newPartnerData.Owner = JwtServices.GetUsername();
            this.newPartnerData.TaraID = 'D31C3594-8D39-4355-9A13-FD699A1B7290';
            this.isPartnerModalVisible = true;
            this.newPartnerData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
            this.sValute = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
        },
        onAddNewBank() {
            this.isBankModalVisible = true;
            this.newBankData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
            this.sValute = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
        },

        onSaveNewPartner() {
            if (!this.newPartnerData.CUI || this.newPartnerData.CUI.trim() === '') {
                notify('Completați câmpul obligatoriu "CUI"!', 'error', 1000);
                return;
            }
            if (!this.newPartnerData.Nume || this.newPartnerData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }

            if (!this.newPartnerData.Fiscal) {
                notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
                return;
            }

            this.grupError = !this.sGrupuri;
            this.zonaError = !this.sZona;

            if (this.grupError || this.zonaError) {
                this.showExtendedDetails = true;
                const msg = this.grupError && this.zonaError
                    ? 'Completați câmpurile obligatorii "Grup" și "Zona"!'
                    : this.grupError
                        ? 'Completați câmpul obligatoriu "Grup"!'
                        : 'Completați câmpul obligatoriu "Zona"!';
                notify(msg, 'error', 2000);
                this.$nextTick(() => {
                    const target = this.grupError ? 'grupDropBox' : 'zonaDropBox';
                    (this.$refs[target] as any)?.$el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
                return;
            }

            console.log(this.newPartnerData);
            const body = this.newPartnerData;

            PAR_Parteneri.save(body).then((response) => {
                this.isPartnerModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);

                const newId = response.data?.ID || response.data?.Id;

                if (newId) {

                    this.formData.AccountID = newId;
                    this.sPartener = newId;


                    if (response.data.Adresa) this.formData.Adresa = response.data.Adresa;
                    if (response.data.TaraID) this.formData.TaraID = response.data.TaraID;
                    if (response.data.JudetID) this.formData.JudetID = response.data.JudetID;

                    console.log("ID setat pentru contact:", this.formData.AccountID);
                    this.$router.push({ name: 'Parteneri', query: { partenerId: newId } });
                }

                this.dsParteneri.reload();

            }).catch((error) => {
                const status = error?.response?.status;
                const data = error?.response?.data;

                if (status === 409 && data?.code === "CUI_EXISTS") {
                    notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
                    return;
                }

                console.error(error);
            });

        },
        onRowClick(e) {
            this.$emit('select-partener', e.data);
        },
        onSaveNewBank() {
            if (!this.newBankData.Nume || this.newBankData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }

            console.log(this.newBankData);
            const body = this.newBankData;
            const savedBankData = { ...this.newBankData };

            PAR_Parteneri.saveBank(body).then((response) => {
                this.isBankModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);

                const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;


                this.dsBanci.reload().then(() => {
                    if (newId) {
                        setTimeout(() => {
                            this.sBanci = newId;

                            this.newPartnerData.Banca = savedBankData.Nume;
                        }, 500);
                    }
                });

                this.newBankData = {
                    PartenerID: null,
                    Cod: null,
                    Nume: null,
                    CodIBAN: null,
                    CodBIC: null,
                    Principala: null,
                    CodSWIFT: null,
                    ValutaID: null,
                    Ordine: null,
                    Activ: null,
                    TextFC: null,
                };
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 1000);
            });
        },

        onAddClick() {
            this.GetUser();
            this.newPartnerData.Owner = this.Username;
            this.newPartnerData.Client = true;
            this.newPartnerData.Furnizor = true;
            this.newPartnerData.Activ = true;
            this.grupError = false;
            this.zonaError = false;
            this.isPartnerModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext();
            notify('Datele au fost actualizate cu succes!', 'success', 1000);
        },
        onExporting(e: any) {
            if (e.format === 'pdf') {
                const doc = new jsPDF();
                exportDataGridPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 5,
                }).then(() => {
                    doc.save('Parteneri.pdf');
                });
            } else if (e.format === 'xlsx') {

                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Parteneri');

                exportDataGridExcel({
                    component: e.component,
                    worksheet,
                    autoFilterEnabled: true,
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer: any) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Parteneri.xlsx');
                    });
                });
                e.cancel = true;
            }
        },
        getInitials(name) {
            if (!name) return '';
            const parts = name.split(' ');
            if (parts.length >= 2) {
                return (parts[0][0] + parts[1][0]).toUpperCase();
            }
            return name.substring(0, 2).toUpperCase();
        },
        handleInternChange(e) {
            if (e.value) {
                this.newPartnerData.Extern = false;
                this.newPartnerData.ExternUE = false;
            }
        },
        handleExternChange(e) {
            if (e.value) {
                this.newPartnerData.Intern = false;
                this.newPartnerData.ExternUE = false;
            }
        },
        handleExternUEChange(e) {
            if (e.value) {
                this.newPartnerData.Intern = false;
                this.newPartnerData.Extern = false;
            }
        },
        getAvatarColor(name) {
            if (!name) return '#ccc';
            let hash = 0;
            for (let i = 0; i < name.length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            const c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
            return '#' + '00000'.substring(0, 6 - c.length) + c;
        },
        async onSearchAnaf() {
            const cuiRaw = this.newPartnerData.CUI;
            if (!cuiRaw) {
                notify("Te rog introdu un CUI valid", "warning", 2000);
                return;
            }

            const cui = Number(String(cuiRaw).replace(/\D/g, ""));
            if (!cui) {
                notify("Te rog introdu un CUI valid", "warning", 2000);
                return;
            }

            try {
                // --- 1. APEL DATE GENERALE (Identitate, TVA, Sediu) ---
                const anafResult = await AnafService.getCompanyDetails(cui);

                if (!anafResult) {
                    notify("CUI-ul nu a fost găsit sau nu există date publice.", "warning", 3000);
                    return;
                }

                const dg = anafResult.date_generale;
                const df = anafResult.adresa_domiciliu_fiscal;
                const ss = anafResult.adresa_sediu_social;
                const formaOrg = String(dg?.forma_organizare ?? "").toUpperCase().trim();
                const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

                // Stabilire regim fiscal (F/P/N)
                let fiscal = null;
                if (formaOrg.includes("PERSOANA FIZICA")) {
                    fiscal = "F";
                } else if (formaOrg.includes("PERSOANA JURIDICA")) {
                    fiscal = scpTVA ? "P" : "N";
                }
                if (fiscal) this.newPartnerData.Fiscal = fiscal;

                // Mapare date de bază
                this.newPartnerData.CUI = String(dg.cui);
                this.newPartnerData.Nume = dg.denumire ?? this.newPartnerData.Nume;
                this.newPartnerData.Numar = dg.nrRegCom ?? this.newPartnerData.Numar;
                this.newPartnerData.Caen = dg.cod_CAEN ?? this.newPartnerData.Caen;
                this.newPartnerData.CAdresa = dg.adresa ?? this.newPartnerData.CAdresa;
                this.newPartnerData.Localitate = ss.sdenumire_Localitate ?? this.newPartnerData.Localitate;
                this.newPartnerData.Strada = ss.sdenumire_Strada ?? this.newPartnerData.Strada;
                this.newPartnerData.Numarstrada = ss.snumar_Strada ?? this.newPartnerData.Numarstrada;
                this.newPartnerData.CP = ss.scod_Postal ?? this.newPartnerData.CodPostal;
                this.newPartnerData.Tel = dg.telefon ?? this.newPartnerData.Tel;

                if (dg.iban) this.newPartnerData.Cont = dg.iban;

                // Logica TVA
                this.newPartnerData.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;

                const extras = [];
                if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
                if (typeof dg.statusRO_e_Factura === "boolean") extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? "DA" : "NU"}`);

                // --- 2. APEL DATE FINANCIARE (Bilanț pentru CifraAfacere și NumarAngajati) ---
                try {
                    // Încercăm anul 2024, cu fallback pe 2023 dacă nu sunt date depuse încă
                    let finData = await AnafService.getFinancialData(cui, 2024);
                    if (!finData || !finData.i || finData.i.length === 0) {
                        finData = await AnafService.getFinancialData(cui, 2023);
                    }

                    if (finData && finData.i) {
                        const indicatori = finData.i;

                        // 1. Căutăm Cifra de Afaceri
                        const caRow = indicatori.find(item => {
                            const nume = item.val_den_indicator.toUpperCase();
                            return nume.includes("CIFRA DE AFACERI NET") || nume === "VENITURI TOTALE";
                        });

                        // 2. Căutăm Numărul de Angajați
                        const angRow = indicatori.find(item => {
                            const nume = item.val_den_indicator.toUpperCase();
                            return nume.includes("NUMAR MEDIU DE SALARIATI") || nume.includes("NR. MEDIU SALARIATI");
                        });

                        // Populare coloane din par_parteneri
                        if (caRow) {
                            this.newPartnerData.CifraAfacere = caRow.val_indicator;
                            extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                        }

                        if (angRow) {
                            this.newPartnerData.NrAngajati = angRow.val_indicator;
                            extras.push(`Angajați: ${angRow.val_indicator}`);
                        }
                    }
                } catch (finError) {
                    console.warn("Datele financiare nu au putut fi încărcate.", finError);
                    // Nu blocăm execuția dacă firma e nouă sau nu are bilanț
                }

                // Finalizare Memo
                if (extras.length) {
                    const prev = this.newPartnerData.Memo ? String(this.newPartnerData.Memo).trim() + "\n" : "";
                    this.newPartnerData.Memo = prev + extras.join(" | ");
                }

                notify("Datele au fost preluate cu succes!", "success", 2000);

            } catch (error) {
                console.error(error);
                notify("Eroare la interogarea ANAF", "error", 4000);
            }
        },
        onDropDownEnterKey(e) {
            if (!e.component.option('opened')) {
                e.component.open();
            }
        },
        onDropDownSearchInput(e, dataSourceName, fieldName = 'Nume') {
            const text = e.event.target.value;
            const ds = this[dataSourceName];
            if (ds) {
                if (text) {
                    ds.filter([fieldName, 'contains', text]);
                } else {
                    ds.filter(null);
                }
                ds.reload();
            }
        },

    },
    watch: {

        sJudet(newId) {
            if (newId) {
                this.dsJudete.store().byKey(newId).then(x => {
                    x.Nume = (x.Nume ?? '(fara nume)');
                    this.judetSelectat = [x];
                });



            } else {
                this.judetSelectat = [];
            }
        },
        // sPartener(newId) {
        //     if (newId) {
        //         this.dsParteneri.store().byKey(newId).then(x => {
        //             if (x) {
        //                 x.Nume = (x.Nume ?? '(fara nume)');
        //                 this.partenerSelectat = [x];
        //             } else {
        //                 this.partenerSelectat = [];
        //             }
        //         }).catch(e => {
        //             console.error("Failed to load partner", e);
        //             this.partenerSelectat = [];
        //         });
        //     } else {
        //         this.partenerSelectat = [];
        //     }
        // },
        sValuta(newId) {
            if (newId) {
                this.dsValuta.store().byKey(newId).then(x => {
                    x.Simbol = (x.Simbol ?? '(fara simbol)');
                    this.valutaSelectat = [x];
                });
            } else {
                this.valutaSelectat = [];
            }
        },
        sParteneriFiscal(newId) {
            if (newId) {
                this.dsParteneriFiscal.store().byKey(newId).then(x => {
                    x.Nume = (x.Nume ?? '(fara nume)');
                    this.partenerFiscalSelectat = [x];
                });



            } else {
                this.partenerFiscalSelectat = [];
            }
        },

    },
    mounted() {
        this.createODataContext();
    },
});
</script>
<style scoped lang="scss">
.footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.02);
}

.contact-card {
    display: flex;
    align-items: center;
    gap: 8px;
    /* Reduced gap */
}

.avatar {
    width: 20px;
    /* Reduced from 36px */
    height: 20px;
    /* Reduced from 36px */
    border-radius: 50%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 11px;
    /* Slightly smaller font */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.contact-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.fullname-text {
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.job-title {
    font-size: 11px;
    color: #888;
    margin-top: -2px;
}

.interactive-link {
    color: #333;
    text-decoration: none;
    transition: color 0.2s;
    font-weight: 500;
}

.interactive-link:hover {
    color: #ff2c21;
    text-decoration: underline;
}

.action-icon-wrapper {
    width: 24px;
    /* Reduced from 28px */
    height: 24px;
    /* Reduced from 28px */
    border-radius: 4px;
    /* Slightly tighter radius */
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    transition: all 0.2s ease;
}

.sales-action:hover {
    background-color: #e6f7ff;
    color: #1890ff;
}

.support-action:hover {
    background-color: #fff7e6;
    color: #fa8c16;
}

.empty-cell {
    color: #ccc;
    font-size: 12px;
}



.form-content {
    flex: 1;
    overflow-y: auto;

    /* spațiu pentru footer */
}

.mobile-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mobile-cell i {
    color: #6b7280;
    font-size: 16px;
}


.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.popup-header-meta {
    display: flex;
    align-items: center;
}

.email-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.email-cell i {
    color: #6b7280;
    font-size: 16px;
}

.owner-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.owner-cell i {
    color: #6b7280;
    font-size: 16px;
}

.fullname-cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.popup-body-simple {
    background: white;
    padding: 3px;
}

.status-chip {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.7);
}

.status-chip--draft {
    background-color: rgba(255, 255, 255, 0.18);
}

// Form Section Simple
:deep(.form-section-simple) {
    .dx-form-group-caption {
        background: #f8f9fa;
        color: #333;
        font-size: 14px;
        font-weight: 600;
        padding: 10px 15px;
        margin: 15px 0 10px 0;
        border-left: 3px solid #ff2c21;
        border-radius: 0;
    }

    .dx-form-group-content {
        background: white;
        padding: 15px 0;
        margin-bottom: 10px;
    }
}

.form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;

}


// Form Fields
:deep(.dx-field-item) {
    margin-bottom: 15px;

    .dx-field-item-label-text {
        font-weight: 500;
        color: #333;
        font-size: 13px;
        margin-bottom: 5px;
    }

    .dx-texteditor,
    .dx-dropdownbox,
    .dx-selectbox {
        border-radius: 4px;
        border-color: #ddd;

        &:hover {
            border-color: #bbb;
        }

        &.dx-state-focused {
            border-color: #ff2c21;
        }
    }

    .dx-texteditor-input {
        padding: 8px 10px;
        font-size: 13px;
    }
}

// Footer Buttons - Simple Style
:deep(.popup-footer-professional) {
    background: white;
    padding: 15px 20px;
    border-top: 1px solid #ddd;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;

    .dx-button {
        border-radius: 4px;
        font-weight: normal;
        padding: 8px 16px;
        min-width: 100px;
        font-size: 13px;
    }
}

:deep(.show-more-btn .dx-button-text) {
    white-space: normal !important;
}

:deep(.show-more-btn .dx-button-content) {
    white-space: normal !important;
    flex-wrap: wrap;
    /* important când ai icon + text */
}

:deep(.show-more-btn) {
    height: 25px;
    width: 400px;
    /* lasă butonul să crească pe verticală */
}


.footer-right .dx-button {
    margin-left: 8px;
}

.footer-left .dx-button {
    margin-left: 8px;
}

/* BODY & SECTIONS */
.popup-body-modern {
    padding: 14px 18px 56px 18px;
}

.footer-fixed {
    position: sticky;
    bottom: 0;
    padding: 10px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    z-index: 10;
}

// Scroll View
:deep(.dx-scrollview-content) {
    padding: 0;
}

.crm-opportunities-container {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
}

.fullname-cell i {
    color: #6b7280;
    font-size: 16px;
}

/* ascunde headerul tabpanel (taburile) */
.wizard-tabs .dx-tabpanel-tabs {
    display: none;
}

/* să nu rămână spațiu gol */
.wizard-tabs .dx-tabpanel-container {
    border-top: none;
}


.fullname-text {
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dx-button-text {
    overflow: visible;
    text-overflow: unset;
}


.dx-button {
    max-width: 100%;
}



// Title, Contact, Company cells with icons
.title-cell,
.contact-cell,
.company-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    i {
        color: #6b7280;
        font-size: 16px;
    }

    .title-text {
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.add-circle-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    padding: 0;
}

.add-circle-btn .dx-icon {
    font-size: 16px;
}
</style>